module.exports = __webpack_public_path__ + "static/media/baseball.e6d7352d.svg";